<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">3.</span>
          <span>Adult Service Priority</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  What is your income as an individual?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.IndividualIncome.Income'
                    )
                  "
                >
                  <el-input
                    type="number"
                    placeholder="$ Annual Income"
                    v-model="adultServicePriority.individualIncome.income"
                  />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text"> What is your family income? </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.FamilyIncome.Income'
                    )
                  "
                >
                  <el-input
                    type="number"
                    placeholder="$ Annual Income"
                    v-model="adultServicePriority.familyIncome.income"
                  />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload documentation confirming your Individual/Family
                  Income.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="familyIncome"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon familyIncome"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="familyIncomeFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                  <p style="font-weight: bold">
                    What documentation can be used for Individual/Family Income?
                    <em @click="showIndividualOrFamilyIncomeDialog"
                      >Click here</em
                    >
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: Documentation must be provided for each applicable income
              source.
            </div>
          </div>
          <p class="heavy-text">Individual Status/Family Size</p>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Would you consider yourself an individual or a member of a
                  family household?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.IndividualOrFamily.IsIndividual'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      adultServicePriority.individualOrFamily.isIndividual
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Individual</el-radio>
                    <el-radio :label="false" size="large"
                      >Member of a family household</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload documentation relating to your Individual
                  Status/Family Size</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="individualOrFamily"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon individualOrFamily"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="individualOrFamilyFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                  <p style="font-weight: bold">
                    What documentation can be used for Individual/Family Status?
                    <em @click="showIndividualOrFamilyStatusDialog"
                      >Click here</em
                    >
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: For individuals with disabilities, the individual’s income
              may be sufficient to determine low-income status. If the
              individual’s income exceeds low-income levels, family income and
              size must be used to determine whether low-income status is met.
            </div>
          </div>

          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <el-dialog
          style="z-index: 1000;word-break: break-word"
          :visible="displayIndividualOrFamilyIncomeDialog"
          :show-close="true"
          width="750px"
        >
          <div slot="title">
            <el-row>
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; padding: 15px 0px 15px 0px; text-align: left"
              >
                <span style="font-size: 25px;"
                  ><b>Individual/Family Income</b></span
                ><br />
                <span style="font-size: 15px;"
                  >What documentation can confirm my individual/family
                  income?</span
                >
              </el-col>
            </el-row>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeIndividualOrFamilyIncomeDialog"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>

          <el-divider></el-divider>
          <el-row style="word-break: break-word">
            <el-col
              :xl="24"
              :lg="24"
              :md="24"
              :xs="24"
              :sm="24"
              style="padding: 15px 0px 15px 0px; text-align: left"
            >
              <span>-Alimony agreement </span><br />
              <span>-Award letter from Veterans Affairs </span><br />
              <span>-Bank statement </span><br />
              <span>-Compensation award letter </span><br />
              <span>-Employer statement/contact </span><br />
              <span>-Family or business financial records </span><br />
              <span>-Pay stubs </span><br />
              <span>-Pension statement </span><br />
              <span>-Public assistance records/printout </span><br />
              <span
                >-Quarterly estimated tax for self-employed persons (Schedule C) </span
              ><br />
              <span>-UI documents and/or printout </span><br />
              <span>-Court award letter </span><br />
              <span>-Self-employment verification form </span><br />
              <span
                >-Other official document issued by a federal, state, or local
                government Career Center such as the Department of Housing and
                Community Affairs or the Department of Family and Protective
                Services (for foster youth), indicating monetary amount of
                assistance </span
              ><br />
              <span
                >-Self-attestation in the absence of available documents listed
                above.</span
              ><br />
            </el-col>
          </el-row>
        </el-dialog>

        <el-dialog
          style="z-index: 1000;word-break: break-word"
          :visible="displayIndividualOrFamilyStatusDialog"
          :show-close="true"
          width="750px"
        >
          <div slot="title">
            <el-row>
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; padding: 15px 0px 15px 0px; text-align: left"
              >
                <span style="font-size: 25px;"
                  ><b>Individual Status/Family Size</b></span
                ><br />
                <span style="font-size: 15px;"
                  >What documentation can confirm my individual status/family
                  size?</span
                >
              </el-col>
            </el-row>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeIndividualOrFamilyStatusDialog"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>

          <el-divider></el-divider>
          <el-row style="word-break: break-word">
            <el-col
              :xl="24"
              :lg="24"
              :md="24"
              :xs="24"
              :sm="24"
              style="padding: 15px 0px 15px 0px; text-align: left"
            >
              <span>-Self-attestation of Family Status form </span><br />
              <span>-Birth certificate </span><br />
              <span>-Decree of court </span><br />
              <span>-Divorce decree </span><br />
              <span>-Marriage certificate</span><br />
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      displayIndividualOrFamilyIncomeDialog: false,
      displayIndividualOrFamilyStatusDialog: false,
      modelState: {},
      loading: false,
      familyIncomeFileList: [],
      individualOrFamilyFileList: [],
      adultServicePriority: {
        individualIncome: {
          income: null,
          clientFiles: []
        },
        familyIncome: {
          income: null,
          clientFiles: []
        },
        individualOrFamily: {
          isIndividual: null,
          clientFiles: []
        }
      },
      newFamilyIncomeUploadInd: false,
      newIndividualOrFamilyUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newFamilyIncomeUploadInd || this.newIndividualOrFamilyUploadInd)
        {
            if(this.adultServicePriority.familyIncome.clientFiles[0].fileId && this.newFamilyIncomeUploadInd){
              this.navigateAwayRemoveAttachment(this.adultServicePriority.familyIncome.clientFiles[0].fileId);
              this.adultServicePriority.familyIncome.clientFiles = [];
            }
            
            if(this.adultServicePriority.individualOrFamily.clientFiles[0].fileId && this.newIndividualOrFamilyUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.adultServicePriority.individualOrFamily.clientFiles[0].fileId);
              this.adultServicePriority.individualOrFamily.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0, 0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          if (res.checklist.adultServicePriority) {
            if (res.checklist.adultServicePriority.individualIncome != null) {
              this.adultServicePriority.individualIncome =
                res.checklist.adultServicePriority.individualIncome;
            }
            if (res.checklist.adultServicePriority.familyIncome != null) {
              this.adultServicePriority.familyIncome =
                res.checklist.adultServicePriority.familyIncome;
              res.checklist.adultServicePriority.familyIncome.clientFiles.forEach(
                element => {
                  this.familyIncomeFileList.push({
                    name: element.fileName,
                    url: element.fileId
                  });
                }
              );
            }
            if (res.checklist.adultServicePriority.individualOrFamily != null) {
              this.adultServicePriority.individualOrFamily =
                res.checklist.adultServicePriority.individualOrFamily;
              res.checklist.adultServicePriority.individualOrFamily.clientFiles.forEach(
                element => {
                  this.individualOrFamilyFileList.push({
                    name: element.fileName,
                    url: element.fileId
                  });
                }
              );
            }
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList) {
      let uploadElement =
        event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url =
        file.url == null && file.name != null ? file.raw.url : file.url;
      const param = {
        objectId: file.url,
        bucketType: BucketType.WioaChecklist
      };
      this.$store
        .dispatch("common/removefile", param)
        .then(() => {
          if (uploadElement.classList.contains("familyIncome")) {
            this.adultServicePriority.familyIncome.clientFiles = [];
          } else if (uploadElement.classList.contains("individualOrFamily")) {
            this.adultServicePriority.individualOrFamily.clientFiles = [];
          }
          this.$message.success("Document removed!");
        })
        .catch(res => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleExceed() {
      this.showPopUpMessage("Upload", `You can only upload 1 file.`);
    },
    showIndividualOrFamilyIncomeDialog() {
      this.displayIndividualOrFamilyIncomeDialog = true;
    },
    closeIndividualOrFamilyIncomeDialog() {
      this.displayIndividualOrFamilyIncomeDialog = false;
    },
    showIndividualOrFamilyStatusDialog() {
      this.displayIndividualOrFamilyStatusDialog = true;
    },
    closeIndividualOrFamilyStatusDialog() {
      this.displayIndividualOrFamilyStatusDialog = false;
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistTwo",
        params: { checklistId: this.getChecklistId() }
      });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        type: 2.1,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          adultServicePriority: this.adultServicePriority
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistFour",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          if (param.action == "familyIncome") {
            this.adultServicePriority.familyIncome.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newFamilyIncomeUploadInd = true;
          } else {
            this.adultServicePriority.individualOrFamily.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newIndividualOrFamilyUploadInd = true;
          }
          param.file.url =
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
